// Advanced Copy Protection Script
// Enhanced security features for content protection

(function() {
  'use strict';

  // Configuration
  const config = {
    disableRightClick: true,
    disableTextSelection: true,
    disableImageDrag: true,
    disableDevTools: false,
    disablePrint: true,
    disableScreenshot: false,
    showWarnings: false
  };

  // Warning messages
  const messages = {
    rightClick: 'Right-click is disabled on this website.',
    devTools: 'Developer tools are not allowed on this website.',
    copy: 'Copying content is not allowed.',
    print: 'Printing is disabled on this website.',
    screenshot: 'Screenshots are not allowed.'
  };

  // Show warning message (disabled)
  function showWarning(message) {
    // Warnings disabled
    return;
  }

  // Disable right-click context menu
  if (config.disableRightClick) {
    document.addEventListener('contextmenu', function(e) {
      e.preventDefault();
      showWarning(messages.rightClick);
      return false;
    }, true);
  }

  // Disable text selection
  if (config.disableTextSelection) {
    document.addEventListener('selectstart', function(e) {
      e.preventDefault();
      return false;
    }, true);
    
    document.addEventListener('mousedown', function(e) {
      if (e.detail > 1) { // Prevent multiple clicks
        e.preventDefault();
      }
    }, true);
  }

  // Disable image dragging
  if (config.disableImageDrag) {
    document.addEventListener('dragstart', function(e) {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    }, true);
  }

  // Disable keyboard shortcuts
  if (config.disableDevTools) {
    document.addEventListener('keydown', function(e) {
      // F12 - Developer Tools
      if (e.keyCode === 123) {
        e.preventDefault();
        showWarning(messages.devTools);
        return false;
      }
      
      // Ctrl+Shift+I - Inspector
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        showWarning(messages.devTools);
        return false;
      }
      
      // Ctrl+Shift+J - Console
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        showWarning(messages.devTools);
        return false;
      }
      
      // Ctrl+Shift+C - Element Selector
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        showWarning(messages.devTools);
        return false;
      }
      
      // Ctrl+U - View Source
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        showWarning(messages.devTools);
        return false;
      }
      
      // Ctrl+A - Select All
      if (e.ctrlKey && e.keyCode === 65) {
        e.preventDefault();
        showWarning(messages.copy);
        return false;
      }
      
      // Ctrl+C - Copy
      if (e.ctrlKey && e.keyCode === 67) {
        e.preventDefault();
        showWarning(messages.copy);
        return false;
      }
      
      // Ctrl+V - Paste
      if (e.ctrlKey && e.keyCode === 86) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+X - Cut
      if (e.ctrlKey && e.keyCode === 88) {
        e.preventDefault();
        showWarning(messages.copy);
        return false;
      }
      
      // Ctrl+S - Save
      if (e.ctrlKey && e.keyCode === 83) {
        e.preventDefault();
        return false;
      }
    }, true);
  }

  // Disable print
  if (config.disablePrint) {
    document.addEventListener('keydown', function(e) {
      // Ctrl+P - Print
      if (e.ctrlKey && e.keyCode === 80) {
        e.preventDefault();
        showWarning(messages.print);
        return false;
      }
    }, true);
    
    // Override print function
    window.print = function() {
      showWarning(messages.print);
      return false;
    };
  }

  // Developer tools detection disabled

  // Console blocking disabled

  // Screenshot blocking disabled

  // Console protection disabled

  // Disable text selection with CSS
  const style = document.createElement('style');
  style.textContent = `
    * {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    
    input, textarea, [contenteditable="true"] {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `;
  document.head.appendChild(style);

  console.log('Advanced copy protection activated');
})();